import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import { customersSelectors } from 'store/reducers/releaseReducers/releaseTaskReducer/customersSlice';
import { registrationSelectors } from 'store/reducers/releaseReducers/releaseTaskReducer/registrationSlice';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import {
  editActions,
  editSelectors,
} from 'store/reducers/releaseReducers/releaseTaskReducer/editSlice';
import { useToast } from 'hooks/useToast';
import * as releaseApi from 'api/releaseApi';
import { useListStore } from './useListStore';

export const useDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchReleaseTasks } = useListStore();
  const selectedReleaseTask = useAppSelector(editSelectors.selectedReleaseTask);
  const isOpenModal = useAppSelector(editSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(editActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteTask = useCallback(() => {
    if (selectedReleaseTask) {
      const TaskId = selectedReleaseTask.taskId
        ? selectedReleaseTask.taskId
        : 0;
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(editActions.updateLoadingStatus(true));
        const result = await releaseApi.deleteTask(TaskId);
        if (result.ok) {
          toast({
            status: 'success',
            description: `タスクを削除しました。`,
          });

          onCloseModal();
          dispatch(editActions.modalOpened());
          void fetchReleaseTasks();
        } else {
          toast({
            status: 'error',
            description: `タスクの削除に失敗しました。`,
          });
        }
        dispatch(editActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `タスクの削除に失敗しました。`,
        });
      });
    }
  }, [selectedReleaseTask, toast, dispatch, onCloseModal, fetchReleaseTasks]);

  const selectedCustomers = useAppSelector(
    customersSelectors.selectedCustomers,
  );
  const shouldShowCustomerList = useAppSelector(
    registrationSelectors.shouldShowCustomerList,
  );

  return {
    /** タスクの内容 */
    values: selectedReleaseTask || {
      taskId: 0,
      taskName: '',
      startsAt: '',
      endsAt: '',
      group: '',
      condition: 'all',
      targets: [],
    },
    /** タスクの削除 */
    onDeleteTask,
    /** タスクの削除キャンセル */
    onCloseModal,
    /** タスク削除確認モーダルの表示状態 */
    isOpenModal,
    selectedCustomers,
    shouldShowCustomerList,
  };
};
